import { useState, useEffect } from 'react'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select'
import { checkboxData } from './checkboxData';
import './style.css'
import { useUserAuth } from '../../context/UserAuthContext';
import { useFormik } from 'formik';
import { liveMusicTtkSchema } from '../schemas';
import axios from "axios";
import ThinksToKnowStatus from './ThinksToKnowStatus';

const LiveMusicBandTTK = () => {
    const workingSinceOption = checkboxData.workSinceOption;
    const eventTypeBandOption = checkboxData.eventTypeBand
    const travelPreferenceOption = checkboxData.travelPreference
    const typeOfArtistOption = checkboxData.typeOfArtist
    const areaOfWorkingOption = checkboxData.areaOfWorking;
    const { user, language, token } = useUserAuth();
    const merchant_id = user.uid;
    const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
    const [merchant, setMerchant] = useState({});
    const getSingleDocumentHandler = async () => {
        try {
            const res = await axios.get(
                `${base_url}/api/v1/thinkstoknow/${merchant_id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
            );
            const data = res.data.data;
            const details = data[0].details;
            // const details = rawDetails ? JSON.parse(rawDetails) : null;
            if (details) {
                setMerchant(details);
                // formik.setValues(details);
            }
        } catch (error) {
            console.log(`Error : ${error}`);
        }
    };
    useEffect(() => {
        if (!merchant_id) return
        getSingleDocumentHandler()
    }, [merchant_id, token])

    const formik = useFormik({
        initialValues: {
            coveredOfEvent: merchant?.coveredOfEvent || '',
            duration: merchant?.duration || '',
            noOfTeam: merchant?.noOfTeam || '',
            workingSince: merchant?.workingSince || [],
            areaOfWork: merchant?.areaOfWork || [],
            eventTypeBand: merchant?.eventTypeBand || [],
            typeOfArtist: merchant?.typeOfArtist || [],
        },
        enableReinitialize: true,
        validationSchema: liveMusicTtkSchema,
        onSubmit: async (values) => {
            try {
                const data = {
                    id: merchant_id,
                    details: { ...values },
                };

                const res = await axios.post(`${base_url}/api/v1/thinkstoknow`, data, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (res.status === 201) {
                    toast.success("Things to know added successfully.");
                    setMerchant(values);
                    formik.setValues(values);
                    setTtkEditMode(false);
                } else if (res.status === 202) {
                    toast.success("Your update is pending approval by the admin.");
                    setTtkEditMode(false);
                } else {
                    toast.info(res.data.message || "Request submitted.");
                    setTtkEditMode(false);
                }

            } catch (error) {
                console.error(`Error ${error}`);
                toast.error('An error occurred while submitting the data.');
            }
        },
    });

    const [ttkEditMode, setTtkEditMode] = useState(false)
    return (
        <div className="page-wrapper">
            <div className="container-fluid">
                 <ThinksToKnowStatus/>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='card'>
                            <div className='card-header  text-white text-center ' style={{ backgroundColor: '#085f9a' }}>
                                <h5> {language === 'en' ? 'Things to Know' : 'जानने योग्य जानकारी भरे'}</h5>
                            </div>
                            <div className='card-body'>
                                {
                                    merchant && (
                                        <>
                                            <div className='table-responsive'>
                                                <table className='table text-center' cellPadding={0} cellSpacing={0} style={{ border: '1px solid #fff ' }}>
                                                    <tbody className='ttk_preview'>
                                                        <tr style={{ color: '#41B0FA' }}>
                                                            <th style={{ width: '25%' }}>Working Since</th>
                                                            <th style={{ width: '25%' }}>Event Types</th>
                                                            <th style={{ width: '25%' }}>Types of Artist</th>
                                                            <th>Areas Of Services</th>
                                                        </tr>
                                                        <tr>
                                                            <td>{
                                                                merchant.workingSince?.map((item, index) => {
                                                                    return <p key={index}>{item.value}</p>
                                                                })
                                                            }</td>
                                                            <td>{
                                                                merchant.eventTypeBand?.map((item, index) => {
                                                                    return <p key={index}>{item.value}</p>
                                                                })
                                                            }</td>
                                                            <td>{
                                                                merchant.typeOfArtist?.map((item, index) => {
                                                                    return (
                                                                        <span key={index}>
                                                                            <i className='fa fa-check text-success' />
                                                                            <span>{item.value} </span>
                                                                        </span>
                                                                    )
                                                                })
                                                            }</td>
                                                            <td>{
                                                                merchant.areaOfWork
                                                                    ?.map((item, index) => {
                                                                        return (<span key={index}>
                                                                            <i className='fa fa-check text-success' />
                                                                            <span >{item.value} </span>
                                                                        </span>)
                                                                    })
                                                            }</td>


                                                        </tr>
                                                        <tr style={{ color: '#41B0FA' }}>
                                                            <th>No. of Events Covered</th>
                                                            <th>Duration</th>
                                                            <th>Team Size</th>

                                                        </tr>
                                                        <tr>

                                                            <td>{merchant.coveredOfEvent}</td>

                                                            <td>{merchant.duration}</td>
                                                            <td>{merchant.noOfTeam}</td>


                                                        </tr>


                                                    </tbody>
                                                </table>
                                            </div>
                                        </>
                                    )
                                }
                                <center >
                                    <button className='btn text-white mb-2' style={{ backgroundColor: '#085f9a' }} onClick={() => setTtkEditMode(!ttkEditMode)}>{`${merchant ? 'Make Changes' : 'Tell me more about yourself'}`}</button>
                                </center>
                                {
                                    ttkEditMode && (
                                        <form onSubmit={formik.handleSubmit}>
                                            <div className='row'>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Working Since <span className='text-danger'>*</span></label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={workingSinceOption}
                                                            selected
                                                            value={formik.values.workingSince}
                                                            onChange={(workingSince) => formik.setFieldValue('workingSince', workingSince)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.workingSince && formik.errors.workingSince ? (
                                                            <div className="text-danger">{formik.errors.workingSince}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Areas Of Services</label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={areaOfWorkingOption}
                                                            selected
                                                            value={formik.values.areaOfWork}
                                                            onChange={(areaOfWork) => formik.setFieldValue('areaOfWork', areaOfWork)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.areaOfWork && formik.errors.areaOfWork ? (
                                                            <div className="text-danger">{formik.errors.areaOfWork}</div>
                                                        ) : null}
                                                    </div>
                                                </div>


                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Event Type<span className='text-danger'>*</span></label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={eventTypeBandOption}
                                                            selected
                                                            value={formik.values.eventTypeBand}
                                                            onChange={(eventTypeBand) => formik.setFieldValue('eventTypeBand', eventTypeBand)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.eventTypeBand && formik.errors.eventTypeBand ? (
                                                            <div className="text-danger">{formik.errors.eventTypeBand}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Types Of Artist<span className='text-danger'>*</span></label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={typeOfArtistOption}
                                                            selected
                                                            value={formik.values.typeOfArtist}
                                                            onChange={(typeOfArtist) => formik.setFieldValue('typeOfArtist', typeOfArtist)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.typeOfArtist && formik.errors.typeOfArtist ? (
                                                            <div className="text-danger">{formik.errors.typeOfArtist}</div>
                                                        ) : null}

                                                    </div>
                                                </div>

                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>No. of Events Covered<span className='text-danger'>*</span></label>
                                                        <input
                                                            type='number'
                                                            placeholder='No. of Events Covered'
                                                            name="coveredOfEvent"
                                                            className='form-control'
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.coveredOfEvent}
                                                        />
                                                        {formik.touched.coveredOfEvent && formik.errors.coveredOfEvent ? (
                                                            <div className="text-danger">{formik.errors.coveredOfEvent}</div>
                                                        ) : null}
                                                    </div>

                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Duration<span className='text-danger'>*</span></label>
                                                        <select
                                                            name="duration"
                                                            className="form-control"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.duration}
                                                        >
                                                            <option selected disabled>Select</option>
                                                            <option value="1 Hour">1 Hour</option>
                                                            <option value="2 Hours">2 Hours</option>
                                                            <option value="3 Hours">3 Hours</option>
                                                            <option value="According to the Event">According to the Event</option>
                                                        </select>
                                                        {formik.touched.duration && formik.errors.duration ? (
                                                            <div className="text-danger">{formik.errors.duration}</div>
                                                        ) : null}
                                                    </div>

                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Team Size<span className='text-danger'>*</span></label>
                                                        <input
                                                            type='number'
                                                            placeholder='Team Size'
                                                            name="noOfTeam"
                                                            className='form-control'
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.noOfTeam}
                                                        />
                                                        {formik.touched.noOfTeam && formik.errors.noOfTeam ? (
                                                            <div className="text-danger">{formik.errors.noOfTeam}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='form-group text-center'>
                                                    <button className='btn text-white' style={{ backgroundColor: '#085f9a' }} type='submit'>{ttkEditMode ? 'Save Changes' : 'Submit'}</button>
                                                </div>
                                            </div>
                                        </form>

                                    )
                                }
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </div>
    )
}
export default LiveMusicBandTTK